import { render, staticRenderFns } from "./AssetOmLogList.vue?vue&type=template&id=c23344b6&scoped=true&"
import script from "./AssetOmLogList.vue?vue&type=script&lang=js&"
export * from "./AssetOmLogList.vue?vue&type=script&lang=js&"
import style0 from "./AssetOmLogList.vue?vue&type=style&index=0&id=c23344b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23344b6",
  null
  
)

export default component.exports